export default __webpack_public_path__ + "static/media/t.268979d8.wav";